import { getFeatureConfig } from '@luna/feature-config';

import type { WebApiSettings } from './SettingsTypes';

// The regexp that can be used to test if the phone number was already masked by the server.
const MASKED_PHONE_NUMBER_TEST_REGEXP = /.{1}\d{1,}xxxxxx\d{3}/;

// The regexp that can be used to mask the phone numbers.
const MASK_PHONE_NUMBER_REPLACE_REGEXP = /(\d{6})\d{3}$/;

// The string to use instead of the numbers.
const PHONE_NUMBER_MASK = 'xxxxxx';

export function getLanguageToSave(language: string): string {
    if (getFeatureConfig((featureConfig) => featureConfig.settings.saveLanguageInUppercase)) {
        return language.toUpperCase();
    }
    return language;
}

function isAlreadyMasked(phoneNumber: string): boolean {
    return MASKED_PHONE_NUMBER_TEST_REGEXP.test(phoneNumber);
}

export function maskTacPhoneNumbers(phoneNumbers: string[]): string[] {
    return phoneNumbers.map((phoneNumber) => {
        if (isAlreadyMasked(phoneNumber)) {
            return phoneNumber;
        }

        const [, partToReplace] = phoneNumber.match(MASK_PHONE_NUMBER_REPLACE_REGEXP) ?? [];

        if (!partToReplace) {
            return phoneNumber;
        }
        return phoneNumber.replace(partToReplace, PHONE_NUMBER_MASK);
    });
}

export function maskTacPhoneNumbersIfExists(settings: WebApiSettings): WebApiSettings {
    if (!settings.tacPhoneNumbers) {
        return settings;
    }

    return {
        ...settings,
        tacPhoneNumbers: maskTacPhoneNumbers(settings.tacPhoneNumbers),
    };
}
